import React from 'react';
import { OptionProps } from 'react-select';
import cn from 'classnames';

import { Guideline } from '@components/common';

import { ITasksToLinkSelectOption } from '@components/ModalComponents/MilestoneForm/Dependencies/utils';

import colors from '@constants/colors';

import styles from './AssociatedTasksSelectOption.module.scss';

const AssociatedTasksSelectOption = (props: OptionProps<ITasksToLinkSelectOption>) => {
	const {
		selectOption,
		data: {
			title,
			taskId,
			startDate,
			endDate,
			isMilestone,
		},
	} = props;

	const handleSelect = () => {
		selectOption(props.data);
	};

	return (
		isMilestone
			? (
				<div className={styles.milestoneTitleContainer}>
					<div className={styles.milestoneTitle}>
						{title}
					</div>
					{startDate && endDate
						&& <Guideline
							guidelineText={`${startDate} - ${endDate}`}
							iconColor={colors.gray40}
							iconHeight='12'
							iconWidth='12'
							placement='bottom'
						/>
					}
				</div>
			)
			: <div
				className={cn(styles.associatedTasksOption, {
					[styles.active]: props.isSelected,
				})}
				onClick={handleSelect}
			>
				<div>{`${taskId} ${title}`}</div>
			</div>
	);
};

export default AssociatedTasksSelectOption;
